import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PropertyGroupApiData } from "../propertyGroupModal";

interface FeaturesSectionProps {
  formData: PropertyGroupApiData;
  onSectionChange: (field: "title" | "description", value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

const FeaturesSection: React.FC<FeaturesSectionProps> = ({
  formData,
  onSectionChange,
  quillModules,
  quillFormats,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Features Section Title
        </label>
        <input
          type="text"
          value={formData.style.features_section.title}
          onChange={(e) =>
            onSectionChange("title", e.target.value)
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Key Features"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Features Section Description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.style.features_section.description}
          onChange={(value) =>
            onSectionChange("description", value)
          }
          modules={quillModules}
          formats={quillFormats}
          placeholder="Description for features section"
        />
      </div>
    </div>
  );
};

export default FeaturesSection;

